import { useEffect } from "react";

interface PageMeta {
  title: string;
  description?: string;
  keywords?: string;
}

/**
 * 设置当前页面的 TDK（标题 / 描述 / 关键词）。
 */
export function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    document.title = title;

    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }

    if (keywords) {
      let tag = document.querySelector('meta[name="keywords"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "keywords");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", keywords);
    }
  }, [title, description, keywords]);
}

export default usePageMeta;